import { css } from '@emotion/react';
import { WeaveLogo } from '@frontend/assets';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text, TextLink } from '@frontend/design-system';
import { WEAVE_PRIVACY_POLICY_URL } from '../../../constants';
import { BOOKING_SITE_TRACKING_IDS } from '../../../trackingIds/booking-site-tracking-ids';

export const Branding = () => {
  const { t } = useTranslation('bookingSite');

  return (
    <div css={containerStyle}>
      <div css={logoStyle}>
        <Text as='span' color='subdued'>
          {t('Scheduling powered by')}
        </Text>
        <WeaveLogo />
      </div>
      <TextLink
        textAlign='center'
        target='_blank'
        to={WEAVE_PRIVACY_POLICY_URL}
        trackingId={BOOKING_SITE_TRACKING_IDS.privacyPolicyLink}
      >
        {t('Privacy policy')}
      </TextLink>
    </div>
  );
};

const containerStyle = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(1.5),
});

const logoStyle = css({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginTop: theme.spacing(5),
  svg: { height: 20, width: 'auto' },
});
